import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'containers/PanesPanel/types';
import { makeSelectLastHistoryCabinet } from 'containers/Configurator/selectors/history';
import { restoreCabinet } from 'containers/Configurator/actions/furniture';
import aluImg from 'assets/images/handles/alu.png';
import woodImg from 'assets/images/handles/wood.png';
import BigOptionButton from 'components/BigOptionButton';
import {
  selectPaintDoorHandleAction,
  updateHandleDoorAction,
} from 'containers/HandlesPanel/actions';
import { DoorHandleType, Material } from 'lib/modelBuilder/constants';
import { useTranslation } from 'react-i18next';
import { PickerTitleCategory } from '../../../components/PickerTitleCategory';
import { ConfiguratorMode, HandlesMode } from '../../ModeBar/reducer';
import {
  makeSelectConfiguratorMode,
  makeSelectPaintHandlesMode,
} from '../../ModeBar/selectors';
import { makeSelectPaintMaterialHandles } from '../selectors';

interface StateProps {
  lastHistoryCabinet: Cabinet;
  mode: ConfiguratorMode;
  handlesMode: HandlesMode;
  paintMaterial: Material | undefined;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  lastHistoryCabinet: makeSelectLastHistoryCabinet(),
  mode: makeSelectConfiguratorMode(),
  handlesMode: makeSelectPaintHandlesMode(),
  paintMaterial: makeSelectPaintMaterialHandles(),
});

const TypePickerLargeDoorHandle = () => {
  const dispatch = useDispatch();
  const { lastHistoryCabinet, mode, handlesMode, paintMaterial } = useSelector(
    stateSelector,
  );
  const { t } = useTranslation();

  const onLeave = () => {
    // Restore the last history element
    if (mode === ConfiguratorMode.selector)
      dispatch(restoreCabinet(lastHistoryCabinet));
  };

  const onClick = (material: Material) => {
    if (mode === ConfiguratorMode.handles) {
      dispatch(
        selectPaintDoorHandleAction(DoorHandleType.Slat, undefined, material),
      );
    } else {
      if (mode === ConfiguratorMode.selector) {
        dispatch(
          updateHandleDoorAction(DoorHandleType.Slat, undefined, material),
        );
      }
    }
  };

  const onHandleHover = (material: Material) => {
    if (mode === ConfiguratorMode.selector) {
      dispatch(
        updateHandleDoorAction(DoorHandleType.Slat, undefined, material, true),
      );
    }
  };

  let activeMaterial: Material | undefined = undefined;
  if (
    mode === ConfiguratorMode.handles &&
    handlesMode === HandlesMode.bigShelves
  ) {
    activeMaterial = paintMaterial;
  }

  return (
    <div className="bg-white">
      <div className="flex bg-gray-300">
        <PickerTitleCategory selected onClick={() => {}}>
          {t('Slats')}
        </PickerTitleCategory>
      </div>

      <div className="flex my-1">
        <BigOptionButton
          imgSrc={woodImg}
          title={t('Wood')}
          handleClick={() => {
            onClick(Material.Wood);
          }}
          handleHover={() => {
            onHandleHover(Material.Wood);
          }}
          onLeave={onLeave}
          selected={activeMaterial === Material.Wood}
        />
        <BigOptionButton
          imgSrc={aluImg}
          title={t('Aluminium')}
          handleClick={() => {
            onClick(Material.Aluminium);
          }}
          handleHover={() => {
            onHandleHover(Material.Aluminium);
          }}
          onLeave={onLeave}
          selected={activeMaterial === Material.Aluminium}
        />
      </div>
    </div>
  );
};

export default TypePickerLargeDoorHandle;
